import { post } from "./ajax";
import notificationToast from "./notification-toast.js";

export default class LSChannel {
    constructor() {
        this.thumbnailUploader = null;
        this.potriatUploader = null;
        this.init();
        this.initializeEventListeners();
        this.initializeSourceToggles();
    }

    init() {
        this.event_handler();
        this.setupValidationRules();

        setTimeout(() => {
            this.initializeSkipDelayVisibility();
            this.triggerInitialStateEvents();
        }, 200);

        jQuery('input[name="ls_adds_enable_disable"]:checked').trigger('change');
        jQuery('select[name="adds_type"]').trigger('change');
        jQuery('input[name="pre_roll_add_display"]:checked').trigger('change');
        jQuery('input[name="mid_roll_add_display"]:checked').trigger('change');
        jQuery('input[name="post_roll_add_display"]:checked').trigger('change');

    }

    /**
     * Trigger initial state events for proper UI initialization
     */
    triggerInitialStateEvents() {
        jQuery('select[name$="[adds_html_structure_type]"]').each(function () {
            jQuery(this).trigger('change');
        });

        jQuery('.enable-skip-toggle-radio:checked').each(function () {
            jQuery(this).trigger('change');
        });
    }

    event_handler() {
        jQuery(document.body)
            .on("click", "#ls_thumbnail_add_button", this.openThumbnailUploader.bind(this))
            .on("click", "#ls_thumbnail_remove_button", this.removeThumbnail.bind(this))
            .on("click", "#ls_potrait_add_button", this.openPotraitUploader.bind(this))
            .on("click", "#ls_potrait_remove_button", this.removePotrait.bind(this))
            .on("click", "#change_channel_status", this.changeStatus.bind(this))
            .on("click", "#wp_list_delete_channel", this.tablelistChannelDelete.bind(this))
            .on('change', 'input[name="ls_adds_enable_disable"]', this.ManageAddSection.bind(this))
            .on('change', 'select[name="adds_type"]', this.handleAddsTypeChange.bind(this))
            .on('change', 'select[name$="[adds_html_structure_type]"]', this.handleAddsStructureChange.bind(this))
            .on('change', '.enable-skip-toggle-radio', this.handleEnableSkipToggleChange.bind(this))
            .on('click', '#add_html_mide_roll_adds_list', this.addHtmlAdds.bind(this))
            .on("change", 'input[name="pre_roll_add_display"]', this.ManagePreRoleAddSection.bind(this))
            .on("change", 'input[name="post_roll_add_display"]', this.ManagePostRoleAddSection.bind(this))
            .on('click', '.ls-copy-shortcode', this.copyShortcode.bind(this))
            .on('change', 'input[name="mid_roll_add_display"]', this.ManageMidRollAddSection.bind(this))
            .on('change', 'input[name="ads_source_preference"]', this.ManageAdsPrefrence.bind(this))
            .on('click', '.ls-toggle-header', this.handleSourceHeaderClick.bind(this))
            .on('submit', '#ls-channel-form', this.validateForm.bind(this));

    }


    setupValidationRules() {

        // Custom validator method for video URL extension
        jQuery.validator.addMethod("videoUrl", function (value, element) {
            if (this.optional(element)) {
                return true;
            }
            // Extract the pathname and check for a valid video extension
            try {
                const url = new URL(value);
                const pathname = url.pathname.toLowerCase();

                const videoExtensions = LSAjax.allow_video_type; // e.g., ['mp4', 'webm']
                // Check if the last segment of the path ends with a video extension
                return videoExtensions.some(ext => pathname.endsWith(`.${ext.toLowerCase()}`));
            } catch (e) {
                return false; // Invalid URL structure
            }
        }, LSAjax.errorMessages.error_invalid_video_url); // Default message
        // NEW: Custom validation method for text with special chars but no symbols

        jQuery.validator.addMethod("namevalidation", function (value, element) {
            if (this.optional(element)) return true;

            // Allow letters (a-z, A-Z), numbers (0-9), whitespace, and special chars like punctuation
            // Disallow symbols like @, #, $, %, etc.
            const regex = /^[a-zA-Z0-9 ]*$/;
            return regex.test(value);
        }, LSAjax.errorMessages.error_title_invalid_pattern);

        // Validation rules
        let baseRules = {
            title: {
                required: true,
                namevalidation: true
            },
            thumbnail_image: {
                required: true
            },
            video_url: {
                required: true,
                videoUrl: true
            },
        };

        // Validation messages
        let baseMessages = {
            title: {
                required: LSAjax.errorMessages.error_title_name,
            },
            thumbnail_image: {
                required: LSAjax.errorMessages.error_thumbnail_image
            },
            video_url: {
                required: LSAjax.errorMessages.error_video_url,
                videoUrl: LSAjax.errorMessages.error_invalid_video_url
            },
        };

        jQuery('#ls-channel-form').validate({
            ignore: [],
            onsubmit: true,
            errorClass: "error-msg",
            errorElement: "p",
            rules: this.getValidationRules(baseRules),
            messages: this.getValidationMessages(baseMessages),
            errorPlacement: function (error, element) {
                if (element.attr('name') === 'title') {
                    element.closest('.form-field').append(error);
                    notificationToast.error(LSAjax.errorMessages.error_title_name, 'Validation Error');
                } else if (element.attr('name') === 'video_url') {
                    // For 'video_url' field
                    element.closest('.form-field').append(error);
                    notificationToast.error(LSAjax.errorMessages.error_video_url, 'Validation Error');
                } else if (element.attr('name') === 'vast_url') {
                    element.closest('.form-field').append(error);
                    notificationToast.error(LSAjax.errorMessages.error_vast_url, 'Validation Error');
                } else if (element.attr('name').match(/^mid_roll_ads\[\d+\]\[adds_url\]$/) ||
                    element.attr('name').match(/^pre_role_add\[\d+\]\[adds_url\]$/)) {
                    // For all 'mid_roll_ads[x][adds_url]' or 'pre_role_add[x][adds_url]' fields
                    element.closest('.form-field').append(error);
                    notificationToast.error(LSAjax.errorMessages.adds_url_required, 'Validation Error');
                } else if (element.attr('name').match(/^mid_roll_ads\[\d+\]\[adds_title\]$/) ||
                    element.attr('name').match(/^pre_role_add\[\d+\]\[adds_title\]$/)) {
                    element.closest('.form-field').append(error);
                    notificationToast.error(error, 'Validation Error');
                }
                else {
                    error.insertAfter(element);
                }
            },
            invalidHandler: (event, validator) => {
                // This function is called when form is invalid
                this.handleValidationErrors(validator);
            }
        });
    }

    getValidationMessages(messages) {
        // Add messages for new rules
        messages.vast_url = {
            required: LSAjax.errorMessages.vast_url,
            url: LSAjax.errorMessages.adds_url_required
        };

        messages.mid_roll_adds_time = {
            number: LSAjax.errorMessages.mid_roll_adds_time_number,
            min: LSAjax.errorMessages.mid_roll_adds_time_min
        }

        messages['mid_roll_ads[0][adds_url]'] = {
            required: LSAjax.errorMessages.adds_url_required,
            url: LSAjax.errorMessages.adds_url_required
        };

        messages['pre_role_add[0][adds_url]'] = {
            required: LSAjax.errorMessages.adds_url_required,
            url: LSAjax.errorMessages.adds_url_required
        };

        messages['mid_roll_ads[0][adds_branding_url]'] = {
            url: LSAjax.errorMessages.adds_url_required
        }

        messages['mid_roll_ads[0][adds_cta_url]'] = {
            url: LSAjax.errorMessages.adds_url_required
        }
        return messages;
    }

    getValidationRules(rules) {

        // Custom validator method for image URL extensions
        jQuery.validator.addMethod("imageUrl", function (value, element) {
            if (this.optional(element)) {
                return true; // Skip if the field is optional
            }

            try {
                const url = new URL(value); // Parse the URL
                const pathname = url.pathname.toLowerCase();

                // Define allowed image extensions (e.g., from LSAjax.allow_image_type)
                const imageExtensions = LSAjax.allow_image_type || ['jpg', 'jpeg', 'png', 'gif', 'webp'];

                // Check if the path ends with a valid image extension
                return imageExtensions.some(ext => pathname.endsWith(`.${ext.toLowerCase()}`));
            } catch (e) {
                return false; // Invalid URL structure
            }
        }, LSAjax.errorMessages.error_invalid_image_url);

        const getMidRollRules = (index) => {
            return {
                [`mid_roll_ads[${index}][skip_duration]`]: {
                    number: function () {
                        return jQuery(`input[name="mid_roll_ads[${index}][enable_skip_button]"]:checked`).val() === 'yes' &&
                            jQuery('input[name="ads_source_preference"]:checked').val() === 'manually' &&
                            jQuery('#adds_type').val() == 'html' &&
                            jQuery(`#adds_html_structure_type_field_${index}`).val() == 'full_screen' &&
                            jQuery('input[name="ls_adds_enable_disable"]:checked').val() == 'enable' &&
                            jQuery('input[name="mid_roll_add_display"]:checked').val() === 'enable';
                    },
                    min: function () {
                        return jQuery(`input[name="mid_roll_ads[${index}][enable_skip_button]"]:checked`).val() === 'yes' &&
                            jQuery('input[name="ads_source_preference"]:checked').val() === 'manually' &&
                            jQuery('#adds_type').val() == 'html' &&
                            jQuery(`#adds_html_structure_type_field_${index}`).val() == 'full_screen' &&
                            jQuery('input[name="ls_adds_enable_disable"]:checked').val() == 'enable' &&
                            jQuery('input[name="mid_roll_add_display"]:checked').val() === 'enable' ? 0 : false;
                    },
                },
                [`mid_roll_ads[${index}][adds_url]`]: {
                    required: function () {
                        return jQuery('input[name="ads_source_preference"]:checked').val() === 'manually' &&
                            jQuery('#adds_type').val() == 'html' &&
                            jQuery(`#adds_html_structure_type_field_${index}`).val() == 'full_screen' &&
                            jQuery('input[name="ls_adds_enable_disable"]:checked').val() == 'enable' &&
                            jQuery('input[name="mid_roll_add_display"]:checked').val() === 'enable';
                    },
                    url: function () {
                        return jQuery('input[name="ads_source_preference"]:checked').val() === 'manually' &&
                            jQuery('#adds_type').val() == 'html' &&
                            jQuery(`#adds_html_structure_type_field_${index}`).val() == 'full_screen' &&
                            jQuery('input[name="ls_adds_enable_disable"]:checked').val() == 'enable' &&
                            jQuery('input[name="mid_roll_add_display"]:checked').val() === 'enable';
                    },
                },
                [`mid_roll_ads[${index}][adds_title]`]: {
                    required: function () {
                        return jQuery('input[name="ads_source_preference"]:checked').val() === 'manually' &&
                            jQuery('#adds_type').val() == 'html' &&
                            jQuery(`#adds_html_structure_type_field_${index}`).val() == 'companion' &&
                            jQuery('input[name="ls_adds_enable_disable"]:checked').val() == 'enable' &&
                            jQuery('input[name="mid_roll_add_display"]:checked').val() === 'enable';
                    }
                },
                [`mid_roll_ads[${index}][adds_branding_url]`]: {
                    url: function () {
                        return jQuery('input[name="ads_source_preference"]:checked').val() === 'manually' &&
                            jQuery('#adds_type').val() == 'html' &&
                            jQuery(`#adds_html_structure_type_field_${index}`).val() == 'companion' &&
                            jQuery('input[name="ls_adds_enable_disable"]:checked').val() == 'enable' &&
                            jQuery('input[name="mid_roll_add_display"]:checked').val() === 'enable';
                    },
                    imageUrl: function () {
                        return jQuery('input[name="ads_source_preference"]:checked').val() === 'manually' &&
                            jQuery('#adds_type').val() == 'html' &&
                            jQuery(`#adds_html_structure_type_field_${index}`).val() == 'companion' &&
                            jQuery('input[name="ls_adds_enable_disable"]:checked').val() == 'enable' &&
                            jQuery('input[name="mid_roll_add_display"]:checked').val() === 'enable';
                    },
                },
                [`mid_roll_ads[${index}][adds_cta_url]`]: {
                    url: function () {
                        return jQuery('input[name="ads_source_preference"]:checked').val() === 'manually' &&
                            jQuery('#adds_type').val() == 'html' &&
                            jQuery(`#adds_html_structure_type_field_${index}`).val() == 'companion' &&
                            jQuery('input[name="ls_adds_enable_disable"]:checked').val() == 'enable' &&
                            jQuery('input[name="mid_roll_add_display"]:checked').val() === 'enable';
                    },
                }
            };
        };

        // Add rules for all existing mid-roll ads on page load
        jQuery('.ls_html_mid_roll_adds').each(function () {
            const index = jQuery(this).attr('rel');

            if (index !== undefined) {
                const midRollRules = getMidRollRules(index);
                jQuery.extend(rules, midRollRules);
            }
        });

        // Add new validation rules
        rules.vast_url = {
            required: function () {
                return jQuery('input[name="ads_source_preference"]:checked').val() === 'manually' && jQuery('#adds_type').val() == 'vast' && jQuery('input[name="ls_adds_enable_disable"]:checked').val() === 'enable';
            },
            url: function () {
                return jQuery('input[name="ads_source_preference"]:checked').val() === 'manually' && jQuery('#adds_type').val() == 'vast' && jQuery('input[name="ls_adds_enable_disable"]:checked').val() === 'enable';
            },
        };

        rules.mid_roll_adds_time = {
            number: function () {
                return jQuery('input[name="ads_source_preference"]:checked').val() === 'manually' && jQuery('#adds_type').val() == 'html' && jQuery('input[name="ls_adds_enable_disable"]:checked').val() == 'enable' && jQuery('input[name="mid_roll_add_display"]:checked').val() === 'enable';
            },
            min: function () {
                return jQuery('input[name="ads_source_preference"]:checked').val() === 'manually' && jQuery('#adds_type').val() == 'html' && jQuery('input[name="ls_adds_enable_disable"]:checked').val() == 'enable' && jQuery('input[name="mid_roll_add_display"]:checked').val() === 'enable' ? 0 : false;
            },
        };


        rules["mid_roll_ads[0][skip_duration]"] = {
            number: function () {
                return jQuery('input[name="mid_roll_ads[0][enable_skip_button]"]:checked').val() === 'yes' && jQuery('input[name="ads_source_preference"]:checked').val() === 'manually' && jQuery('#adds_type').val() == 'html' && jQuery(`#adds_html_structure_type_field_0`).val() == 'full_screen' && jQuery('input[name="ls_adds_enable_disable"]:checked').val() == 'enable' && jQuery('input[name="mid_roll_add_display"]:checked').val() === 'enable';
            },
            min: function () {
                return jQuery('input[name="mid_roll_ads[0][enable_skip_button]"]:checked').val() === 'yes' && jQuery('input[name="ads_source_preference"]:checked').val() === 'manually' && jQuery('#adds_type').val() == 'html' && jQuery(`#adds_html_structure_type_field_0`).val() == 'full_screen' && jQuery('input[name="ls_adds_enable_disable"]:checked').val() == 'enable' && jQuery('input[name="mid_roll_add_display"]:checked').val() === 'enable' ? 0 : false;
            },
        }

        rules['mid_roll_ads[0][adds_url]'] = {
            required: function () {
                return jQuery('input[name="ads_source_preference"]:checked').val() === 'manually' && jQuery('#adds_type').val() == 'html' && jQuery(`#adds_html_structure_type_field_0`).val() == 'full_screen' && jQuery('input[name="ls_adds_enable_disable"]:checked').val() == 'enable' && jQuery('input[name="mid_roll_add_display"]:checked').val() === 'enable';
            },
            url: function () {
                return jQuery('input[name="ads_source_preference"]:checked').val() === 'manually' && jQuery('#adds_type').val() == 'html' && jQuery(`#adds_html_structure_type_field_0`).val() == 'full_screen' && jQuery('input[name="ls_adds_enable_disable"]:checked').val() == 'enable' && jQuery('input[name="mid_roll_add_display"]:checked').val() === 'enable';
            },
        };

        rules['mid_roll_ads[0][adds_title]'] = {
            required: function () {
                return jQuery('input[name="ads_source_preference"]:checked').val() === 'manually' && jQuery('#adds_type').val() == 'html' && jQuery(`#adds_html_structure_type_field_0`).val() == 'companion' && jQuery('input[name="ls_adds_enable_disable"]:checked').val() == 'enable' && jQuery('input[name="mid_roll_add_display"]:checked').val() === 'enable';
            }
        }
        rules['pre_role_add[0][adds_url]'] = {
            required: function () {
                return jQuery('input[name="ads_source_preference"]:checked').val() === 'manually' && jQuery('#adds_type').val() == 'html' && jQuery('input[name="pre_roll_add_display"]:checked').val() === 'enable' && jQuery('input[name="ls_adds_enable_disable"]:checked').val() == 'enable';
            },
            url: function () {
                return jQuery('input[name="ads_source_preference"]:checked').val() === 'manually' && jQuery('#adds_type').val() == 'html' && jQuery('input[name="pre_roll_add_display"]:checked').val() === 'enable' && jQuery('input[name="ls_adds_enable_disable"]:checked').val() == 'enable';
            },
        };

        rules['mid_roll_ads[0][adds_branding_url]'] = {
            url: function () {
                return jQuery('input[name="ls_adds_enable_disable"]:checked').val() == 'enable'
            },
            imageUrl: function () {
                return jQuery('input[name="ls_adds_enable_disable"]:checked').val() == 'enable'
            },
        }
        rules['mid_roll_ads[0][adds_cta_url]'] = {
            url: function () {
                return jQuery('input[name="ls_adds_enable_disable"]:checked').val() == 'enable'
            },
        }
        return rules;
    }

    openThumbnailUploader(event) {
        event.preventDefault();

        if (this.thumbnailUploader) {
            this.thumbnailUploader.open();
            return;
        }

        this.thumbnailUploader = wp.media({
            title: LSAjax.wp_media_choose_image_title,
            multiple: false,
            library: { type: 'image' }
        });

        this.thumbnailUploader.on('select', () => {
            const attachment = this.thumbnailUploader.state().get('selection').first().toJSON();
            let fileType = attachment.subtype;

            const allowedTypes = LSAjax.allow_image_type;
            if (!allowedTypes.includes(fileType)) {
                notificationToast.error(LSAjax.errorMessages.error_invalid_image, 'Error')
            } else {
                // Custom handler for valid files
                this.updateThumbnail(attachment);
            }
        });


        this.thumbnailUploader.open();
    }

    updateThumbnail(attachment) {
        jQuery('#ls_thumbnail_container').html(`
            <img src="${attachment.url}" alt="Thumbnail" style="max-width: 150px;">
        `);
        jQuery('#thumbnail_id').val(attachment.id);
    }

    removeThumbnail(event) {
        event.preventDefault();
        jQuery('#ls_thumbnail_container').empty();
        jQuery('#thumbnail_id').val('');
    }

    openPotraitUploader(event) {
        event.preventDefault();

        if (this.potriatUploader) {
            this.potriatUploader.open();
            return;
        }

        this.potriatUploader = wp.media({
            title: LSAjax.wp_media_choose_image_title,
            multiple: false,
            library: { type: 'image' }
        });

        this.potriatUploader.on('select', () => {
            const attachment = this.potriatUploader.state().get('selection').first().toJSON();
            let fileType = attachment.subtype;

            const allowedTypes = LSAjax.allow_image_type;
            if (!allowedTypes.includes(fileType)) {
                notificationToast.error(LSAjax.errorMessages.error_invalid_image, 'Error')
            } else {
                // Custom handler for valid files
                this.updatepotrait(attachment);
            }
        });

        this.potriatUploader.open();
    }

    updatepotrait(attachment) {
        jQuery('#ls_potrait_container').html(`
            <img src="${attachment.url}" alt="Thumbnail" style="max-width: 150px;">
        `);
        jQuery('#_portrait_thumbmail').val(attachment.id);
    }

    removePotrait(event) {
        event.preventDefault();
        jQuery('#ls_potrait_container').empty();
        jQuery('#_portrait_thumbmail').val('');
    }

    lsChannelForm(event) {

        let submitButton = jQuery('#ls-channel-form input[type="submit"]');
        submitButton.attr('type', 'button');
        let data = {
            title: jQuery('#title').val(),
            author: jQuery('#author').val(),
            content: jQuery('#content').val(),
            status: jQuery('#status').val(),
            channel_id: jQuery('#channel_id').val(),
            manage_ls_channel_form_nonce: jQuery('#manage_ls_channel_form_nonce').val(),
            slug: jQuery('#slug').val(),
            thumbnail_image: jQuery('#thumbnail_id').val(),
            _portrait_thumbmail: jQuery('#_portrait_thumbmail').val(),
            video_url: jQuery('#video_url').val(),
            linked_recommended_channel_ids: jQuery('#linked_recommended_channel_ids').val(),
            channel_category: jQuery('#channel_category').val(),
            seo_description: jQuery('#seo_description').val(),
            epg_channel_id: jQuery('#epg_channel_id').val(),
            ads_source_preference: jQuery('input[name="ads_source_preference"]:checked').val(),
            // Ads Configuration
            adds_display: jQuery('input[name="ls_adds_enable_disable"]:checked').val(),
            adds_type: jQuery('#adds_type').val(),
            vast_url: jQuery('#vast_url').val(),

            // HTML Ads Specific Toggles
            pre_roll_add_display: jQuery('input[name="pre_roll_add_display"]:checked').val(),
            mid_roll_add_display: jQuery('input[name="mid_roll_add_display"]:checked').val(),
            post_roll_add_display: jQuery('input[name="post_roll_add_display"]:checked').val(),

            mid_roll_adds_time: jQuery('#mid_roll_adds_time').val(),

            mid_roll_ads: [],
            pre_role_add: [],
            post_role_add: []

        };

        jQuery('.ls-ad-block-mid_roll').each(function () {
            const $adBlock = jQuery(this);
            const ad = {};

            ad.adds_html_structure_type = $adBlock.find('select[name$="[adds_html_structure_type]"]').val();
            ad.adds_url = $adBlock.find('input[name$="[adds_url]"]').val();
            ad.adds_background_color = $adBlock.find('input[name$="[adds_background_color]"]').val();
            ad.adds_title = $adBlock.find('input[name$="[adds_title]"]').val();
            ad.adds_desc = $adBlock.find('textarea[name$="[adds_desc]"]').val();
            ad.adds_branding_url = $adBlock.find('input[name$="[adds_branding_url]"]').val();
            ad.adds_cta_url = $adBlock.find('input[name$="[adds_cta_url]"]').val();
            ad.adds_cta_text = $adBlock.find('input[name$="[adds_cta_text]"]').val();
            ad.enable_skip_button = $adBlock.find('input[name$="[enable_skip_button]"]:checked').val();
            ad.skip_duration = $adBlock.find('input[name$="[skip_duration]"]').val();
            ad.duration = parseInt($adBlock.find('input[name$="[duration]"]').val(), 10) || 5;

            data.mid_roll_ads.push(ad);
        });

        this.collectPreRollAds(data.pre_role_add);
        const currentFrom = jQuery(event.currentTarget);
        const validator = currentFrom.validate({
            invalidHandler: (event, validator) => {
                // This function is called when form is invalid
                this.handleValidationErrors(validator);
            }
        });
        if (currentFrom.valid()) {
            if (data.channel_id) {
                this.updateChannel(data);
            } else {
                this.addChannel(data);
            }
        } else {
            submitButton.attr('type', 'submit');
            notificationToast.error(LSAjax.errorMessages.error_common, 'Error');
        }
    }

    // Function to handle validation errors
    handleValidationErrors(validator) {

        jQuery('.ls-validation-error-message').each(function () {
            jQuery(this).find('span.error-msg').remove();
        });



        // Add error indicators for current errors
        validator.errorList.forEach(function (error) {
            const adsElement = jQuery(error.element).closest('.ls-validation-error');
            var validationError = adsElement.find('.ls-validation-error-message');

            if (validationError.length > 0) {
                // Check if error span doesn't already exist
                if (validationError.find('> span.tab-error').length === 0) {
                    validationError.find('.title-text').append('<span class="error-msg"> Error</span>');
                }
            }
        });
    }

    collectPreRollAds(targetArray) {
        jQuery('.ls-ad-block-pre_roll').each(function (index, element) {
            let ad = {};
            ad.adds_html_structure_type = jQuery(element).find('select[name$="[adds_html_structure_type]"]').val() || 'full_screen';
            ad.adds_url = jQuery(element).find('input[name$="[adds_url]"]').val();
            ad.enable_skip_button = jQuery(element).find('input[name$="[enable_skip_button]"]:checked').val();
            ad.skip_duration = jQuery(element).find('input[name$="[skip_duration]"]').val();
            targetArray.push(ad);
        });
    }

    addChannel(data) {
        post('ls_add_channel', data).then(response => {
            if (response.success) {
                notificationToast.success(response.data.message, 'Success');
                var location = window.location.href.split("?");
                window.location.href = location[0] + "?page=ls-channel-add&id=" + response.data?.channel_id;

            } else {
                notificationToast.error(response.data.message, 'Error');
                setTimeout(() => {
                    location.reload();
                });
            }
        }).catch(error => {
            console.error(error);
            notificationToast.error('An unexpected error occurred. Please try again.', 'Error');
        });
    }

    updateChannel(data) {
        post('ls_update_channel', data).then(response => {
            if (response.success) {
                notificationToast.success(response.data.message, 'Success');
                setTimeout(() => {
                    location.reload();
                }, 2000);
            } else {
                notificationToast.error(response.data.message, 'Error');
                setTimeout(() => {
                    location.reload();
                }, 2000);
            }
        }).catch(error => {
            console.error(error);
            notificationToast.error('An unexpected error occurred. Please try again.', 'Error');
        });
    }


    handleAddsStructureChange(event) {
        const selectedValue = event.target.value;
        const parentContainer = jQuery(event.target).closest('.ls_html_mid_roll_adds, .ls-ad-block-mid_roll, .ls_html_pre_roll_adds, .ls-ad-block-pre_roll, .ls_html_post_roll_adds, .ls-ad-block-post_roll');
        const counter = parentContainer.attr('rel');

        const addsUrl = parentContainer.find('.adds_video_url_section');
        const otherFields = parentContainer.find('.common_adds_fields');
        const skipOptions = parentContainer.find('.skip-button-options');

        // Hide all sections initially
        addsUrl.addClass('hidden');
        otherFields.addClass('hidden');
        skipOptions.addClass('hidden');

        if (selectedValue === 'full_screen') {
            // Show video URL and skip options for full screen ads
            addsUrl.removeClass('hidden');
            skipOptions.removeClass('hidden');
            // Update skip delay label
            skipOptions.find('.skip_delay_section label').text('Skippable After (seconds)');
        } else if (selectedValue === 'companion' || selectedValue === 'overlay') {
            // Show common fields for companion/overlay ads
            otherFields.removeClass('hidden');
            // Hide skip options for non-full screen ads
            skipOptions.addClass('hidden');
        }

        // Trigger skip toggle check
        const skipToggle = parentContainer.find('.enable-skip-toggle-radio:checked');
        if (skipToggle.length) {
            this.handleEnableSkipToggleChange({ target: skipToggle[0] });
        }
    }

    changeStatus(event) {
        event.preventDefault();
        const target = event.target;

        let href = jQuery(target).attr("href");

        if (href === undefined) {
            const closestElement = jQuery(target).closest('#change_channel_status');
            if (closestElement.length) {
                href = closestElement.attr("href");
            }
        }

        if (!href) {
            return;
        }
        const params = new URLSearchParams(href.split('?')[1]);

        const action = params.get('action');
        const id = params.get('id');

        if (!action || !id) {
            return;
        }

        const data = {
            status: action,
            channel_id: id
        };

        post('ls_change_channel_status', data)
            .then(response => {
                if (response.success) {
                    notificationToast.success(response.data.message, 'Success');
                    location.reload();
                } else {
                    notificationToast.error(response.data.message, 'Error');
                    location.reload();
                }
            })
            .catch(error => {
                notificationToast.error('An unexpected error occurred. Please try again.', 'Error');
                location.reload();
            });

    }

    tablelistChannelDelete(event) {
        event.preventDefault();

        let channelId = event.target.getAttribute('data-id');

        if (!channelId) {
            const closestElement = jQuery(event.target).closest('#wp_list_delete_channel');
            if (closestElement.length) {
                channelId = closestElement.attr('data-id');
            }
        }

        if (channelId) {
            // Confirmation alert
            const confirmed = window.confirm('Are you sure you want to delete this channel?');
            if (!confirmed) {
                return; // Exit if user cancels
            }

            let data = { channel_id: channelId };
            post('delete_tablelist_channel', data).then(response => {
                if (response.success) {
                    notificationToast.success(response.data.message, 'Success');
                    location.reload();
                } else {
                    notificationToast.error(response.data.message, 'Error');
                    location.reload();
                }
            }).catch(error => {
                notificationToast.error('An unexpected error occurred. Please try again.', 'Error');
                location.reload();
            });
        }
    }



    ManageAddSection(event) {
        jQuery('#adds_display').toggleClass('hidden', event.target.value !== 'enable');
    }

    ManagePreRoleAddSection(event) {
        jQuery('.pre_roll_add_data').toggleClass('hidden', event.target.value !== 'enable');
    }

    ManagePostRoleAddSection(event) {
        jQuery('.post_roll_add_data').toggleClass('hidden', event.target.value !== 'enable');
    }

    handleAddsTypeChange(event) {
        const selectedType = event.target.value;
        const vastSection = jQuery('#adds_type_vast');
        const htmlSection = jQuery('#adds_type_html');

        if (selectedType === 'vast') {
            vastSection.removeClass('hidden');
            htmlSection.addClass('hidden');
        } else if (selectedType === 'html') {
            htmlSection.removeClass('hidden');
            vastSection.addClass('hidden');
        }
    }

    // Add these helper methods to your class
    addDynamicValidationRule(fieldName, rule, formSelector) {
        // Store dynamic rules for later use
        if (!this.dynamicRules) {
            this.dynamicRules = {};
        }
        this.dynamicRules[fieldName] = rule;

        // Apply the rule to existing validator if it exists
        const validator = jQuery(formSelector).data('validator');

        if (validator) {
            validator.settings.rules[fieldName] = rule;
        }
    }

    addDynamicValidationMessage(fieldName, message, formSelector) {
        // Store dynamic messages for later use
        if (!this.dynamicMessages) {
            this.dynamicMessages = {};
        }
        this.dynamicMessages[fieldName] = message;

        // Apply the message to existing validator if it exists
        const validator = jQuery(formSelector).data('validator');
        if (validator) {
            validator.settings.messages[fieldName] = message;
        }
    }

    addHtmlAdds(event) {
        event.preventDefault();
        var lastSource = jQuery('.mid_roll_adds_list .ls_html_mid_roll_adds').last();
        var relValue = lastSource.attr('rel');
        if (relValue == undefined) {
            relValue = 0;
        } else {
            relValue = parseInt(relValue, 10) + 1;
        }

        post('add_html_add_structure', {
            structure_id: relValue,
            _ajax_nonce: window.streamitAjax,
        })
            .then(res => {
                var appendedContent = jQuery(res.data);

                var newRelValue = appendedContent.attr('rel');

                const formSelectors = ['#insert_movie', '#insert_video', '#insert_tvshow', '#ls-channel-form'];
                const urlFields = [
                    {
                        name: `mid_roll_ads[${newRelValue}][adds_url]`, rule: {
                            required: function () {
                                return jQuery(`#adds_html_structure_type_field_${newRelValue}`).val() == 'full_screen' && jQuery('#adds_type').val() == 'html' && jQuery('input[name="ls_adds_enable_disable"]:checked').val() == 'enable' && jQuery('input[name="mid_roll_add_display"]:checked').val() === 'enable';
                            },
                            url: function () {
                                return jQuery(`#adds_html_structure_type_field_${newRelValue}`).val() == 'full_screen' && jQuery('#adds_type').val() == 'html' && jQuery('input[name="ls_adds_enable_disable"]:checked').val() == 'enable' && jQuery('input[name="mid_roll_add_display"]:checked').val() === 'enable';
                            },
                        }
                    },
                    {
                        name: `mid_roll_ads[${newRelValue}][adds_title]`, rule: {
                            required: function () {
                                return jQuery(`#adds_html_structure_type_field_${newRelValue}`).val() == 'companion' && jQuery('#adds_type').val() == 'html' && jQuery('input[name="ls_adds_enable_disable"]:checked').val() == 'enable' && jQuery('input[name="mid_roll_add_display"]:checked').val() === 'enable';
                            }
                        }
                    },
                    {
                        name: `mid_roll_ads[${newRelValue}][adds_branding_url]`, rule: {
                            url: function () {
                                return jQuery('input[name="ads_source_preference"]:checked').val() === 'manually' && jQuery('#adds_type').val() == 'html' && jQuery(`#adds_html_structure_type_field_${relValue}`).val() == 'companion' && jQuery('input[name="ls_adds_enable_disable"]:checked').val() == 'enable' && jQuery('input[name="mid_roll_add_display"]:checked').val() === 'enable';
                            },
                            imageUrl: function () {
                                return jQuery('input[name="ads_source_preference"]:checked').val() === 'manually' && jQuery('#adds_type').val() == 'html' && jQuery(`#adds_html_structure_type_field_${relValue}`).val() == 'companion' && jQuery('input[name="ls_adds_enable_disable"]:checked').val() == 'enable' && jQuery('input[name="mid_roll_add_display"]:checked').val() === 'enable';
                            },
                        }
                    },
                    {
                        name: `mid_roll_ads[${newRelValue}][adds_cta_url]`, rule: {
                            url: function () {
                                return jQuery('input[name="ads_source_preference"]:checked').val() === 'manually' && jQuery('#adds_type').val() == 'html' && jQuery(`#adds_html_structure_type_field_${relValue}`).val() == 'companion' && jQuery('input[name="ls_adds_enable_disable"]:checked').val() == 'enable' && jQuery('input[name="mid_roll_add_display"]:checked').val() === 'enable';
                            },
                        }
                    },
                    {
                        name: `mid_roll_ads[${newRelValue}][skip_duration]`, rule: {
                            number: function () {
                                return jQuery('input[name="ads_source_preference"]:checked').val() === 'manually' && jQuery('input[name="ls_adds_enable_disable"]:checked').val() == 'enable' && jQuery('input[name="post_roll_add_display"]:checked').val() == 'enable'
                            },
                            min: function () {
                                return jQuery('input[name="ads_source_preference"]:checked').val() === 'manually' && jQuery('input[name="ls_adds_enable_disable"]:checked').val() == 'enable' && jQuery('input[name="post_roll_add_display"]:checked').val() == 'enable' ? 0 : false
                            },
                        }
                    }
                ];

                formSelectors.forEach(formSelector => {
                    urlFields.forEach(field => {
                        this.addDynamicValidationRule(field.name, field.rule, formSelector);
                    });
                });

                // Validation messages
                const messageFields = [
                    { name: `mid_roll_ads[${newRelValue}][adds_branding_url]`, message: { url: LSAjax.errorMessages.error_url_formate || 'Please enter a valid URL' } },
                    { name: `mid_roll_ads[${newRelValue}][adds_cta_url]`, message: { url: LSAjax.errorMessages.error_url_formate || 'Please enter a valid URL' } },
                    {
                        name: `mid_roll_ads[${newRelValue}][adds_url]`, message: {
                            required: LSAjax.errorMessages.adds_url_required || 'Mid roll ad URL is required',
                            url: LSAjax.errorMessages.error_url_formate || 'Please enter a valid URL'
                        }
                    },
                ];

                formSelectors.forEach(formSelector => {
                    messageFields.forEach(field => {
                        this.addDynamicValidationMessage(field.name, field.message, formSelector);
                    });
                });
                jQuery('.mid_roll_adds_list').append(appendedContent);
                jQuery('.ls_select2').select2({
                    width: '100%'
                });

            })
            .catch(() => {
                notificationToast.error('An unexpected error occurred. Please try again.', 'Error');
            });
    }



    handleEnableSkipToggleChange(event) {
        const parentAdBlock = jQuery(event.target).closest('.ls_html_mid_roll_adds, .ls-ad-block-mid_roll, .ls_html_pre_roll_adds, .ls-ad-block-pre_roll, .ls_html_post_roll_adds, .ls-ad-block-post_roll');
        const skipDelaySection = parentAdBlock.find('.skip_delay_section');
        const isEnabled = event.target.value === 'yes';
        const isPreRoll = parentAdBlock.hasClass('ls_html_pre_roll_adds') || parentAdBlock.hasClass('ls-ad-block-pre_roll');
        const isPostRoll = parentAdBlock.hasClass('ls_html_post_roll_adds') || parentAdBlock.hasClass('ls-ad-block-post_roll');
        const structureType = parentAdBlock.find('select[name$="[adds_html_structure_type]"]').val();

        // Show/hide skip delay section based on conditions
        (isPreRoll || isPostRoll || structureType === 'full_screen') && skipDelaySection.toggleClass('hidden', !isEnabled);
    }

    /**
     * Sets the initial visibility of the skip delay field for a given ad block element.
     * @param {HTMLElement} adBlockElement The ad block element (e.g., .ls_html_mid_roll_adds).
     */
    initializeSkipDelayVisibilityForElement(adBlockElement) {
        const $adBlockElement = jQuery(adBlockElement);

        const isPreRoll = $adBlockElement.hasClass('ls_html_pre_roll_adds') || $adBlockElement.hasClass('ls-ad-block-pre_roll');
        const structureType = $adBlockElement.find('select[name$="[adds_html_structure_type]"]').val();

        if (isPreRoll || structureType === 'full_screen') {
            const $enableSkipRadio = $adBlockElement.find('input[name$="[enable_skip_button]"]:checked');
            const $skipDelaySection = $adBlockElement.find('.skip_delay_section');

            if ($enableSkipRadio.val() === 'yes') {
                $skipDelaySection.removeClass('hidden');
            } else {
                $skipDelaySection.addClass('hidden');
            }
        }
    }

    /**
     * Initializes the skip delay visibility for all existing ad blocks on the page.
     */
    initializeSkipDelayVisibility() {
        jQuery('.ls_html_mid_roll_adds, .ls_html_pre_roll_adds, .ls_html_post_roll_adds').each((index, element) => {
            this.initializeSkipDelayVisibilityForElement(element);
        });

        jQuery('.ls-ad-block-mid_roll, .ls-ad-block-pre_roll, .ls-ad-block-post_roll').each((index, element) => {
            this.initializeSkipDelayVisibilityForElement(element);
        });
    }


    ManageMidRollAddSection(event) {
        const value = event.target.value;
        const addsElement = jQuery('.mid_roll_adds_list');

        if (value === 'enable') {
            addsElement.removeClass('hidden').fadeIn(300);
        } else {
            addsElement.fadeOut(300, function () {
                jQuery(this).addClass('hidden');
            });
        }
    }

    validateForm(event) {
        event.preventDefault();

        this.lsChannelForm(event);
    }

    initializeEventListeners() {
        jQuery('input[name="pre_roll_add_display"], input[name="mid_roll_add_display"]').on('change', this.handleAdsSectionToggle.bind(this));
        jQuery('.ls-add-html-ad').on('click', this.addHtmlAd.bind(this));

    }

    handleAdsSectionToggle(event) {
        const $target = jQuery(event.target);
        const sectionType = $target.attr('name').includes('pre_roll') ? 'pre' : 'mid';
        const $contentSection = jQuery(`.${sectionType}-roll-ads .${sectionType}_roll_add_data`);

        if ($target.val() === 'enable') {
            $contentSection.removeClass('hidden').hide().fadeIn(300);
        } else {
            $contentSection.fadeOut(300, function () {
                jQuery(this).addClass('hidden');
            });
        }
    }

    async addHtmlAd(event) {
        event.preventDefault();
        const button = event.currentTarget;
        const adType = button.dataset.type;
        const container = jQuery(button).closest('.mid-roll-ads-container').find('.mid-roll-ads-list');
        const counter = container.children().length;

        //
        const $newAd = jQuery('.ls-ad-block-mid_roll').last();
        if ($newAd.length) {
            $newAd.find('.ls-metabox-content').hide();
            $newAd.addClass('closed');
        }

        try {
            const response = await jQuery.ajax({
                url: window.ajaxurl,
                type: 'POST',
                data: {
                    action: 'ls_ajax_post',
                    route_name: 'add_html_ad_template',
                    _ajax_nonce: window.LSAjax._ajax_nonce,
                    ad_type: adType,
                    counter: counter
                }
            });

            if (response.success) {
                const newAd = jQuery(response.data.html);
                container.append(newAd);

                newAd.hide().fadeIn(300);

                this.initializeAdComponents(newAd);
            } else {
                console.error('Error adding HTML ad:', response.data.message);
            }
        } catch (error) {
            console.error('Error adding HTML ad:', error);
        }
    }

    initializeAdComponents($adElement) {
        $adElement.find('select').select2({
            minimumResultsForSearch: -1
        });

        this.setupValidation($adElement);
    }

    setupValidation($adElement) {
        $adElement.find('input[required]').on('change', function () {
            const input = jQuery(this);
            if (!input.val()) {
                input.addClass('invalid');
            } else {
                input.removeClass('invalid');
            }
        });
    }

   

    ManageAdsPrefrence(event) {
        jQuery('#ls-manually-adds').toggleClass('hidden', event.target.value !== 'manually');

    }

    initializeSourceToggles() {
        // Initialize states for existing ads
        jQuery('.ls-metabox').each((index, element) => {
            const $element = jQuery(element);
            const structureType = $element.find('select[name$="[adds_html_structure_type]"]').val();
            const skipEnabled = $element.find('.enable-skip-toggle-radio:checked').val() === 'yes';

            if (structureType === 'full_screen') {
                $element.find('.skip-button-options').removeClass('hidden');
                $element.find('.skip_delay_section').toggleClass('hidden', !skipEnabled);
            }
        });
    }

    handleSourceHeaderClick(event) {
        if (jQuery(event.target).closest('.remove-btn').length) {
            return;
        }

        const $header = jQuery(event.currentTarget).find('h3');
        const $metabox = $header.closest('.ls-metabox');
        const $content = $metabox.find('.ls_advertisement_data');

        // Toggle the visibility
        $content.toggle();

    }

    toggleSource($metabox) {
        $metabox.toggleClass('closed');
        $metabox.find('.ls-metabox-content').slideToggle('fast');
    }

    copyShortcode(event) {
        const shortcode = jQuery(event.currentTarget).data('shortcode');

        if (!shortcode) return;

        // Create a temporary textarea to copy the shortcode
        const $temp = jQuery('<textarea>');
        jQuery('body').append($temp);
        $temp.val(shortcode).select();
        try {
            document.execCommand('copy');
            alert(LSAjax.shortcode_copy_success);
        } catch (err) {
            alert(LSAjax.shortcode_copy_fail);
        }
        $temp.remove();
    }
}